module.exports = __webpack_public_path__ + "4a5d7338372f263abea10e5208550c70.MP3";